import { useQuery } from "@tanstack/react-query";
import type { TApiODIN } from "@/apis/odin/apiODIN";
import { adminKeys } from "@/queries/queryKeys";

export const createAdminQueryHooks = ({ apiODIN }: { apiODIN: TApiODIN }) => {
    const useAdminDatabasesQuery = (options?: { enabled?: boolean }) =>
        useQuery({
            queryKey: adminKeys.databases(),
            queryFn: async () => {
                const response = await apiODIN.getAdminDatabases();
                return response.data;
            },
            enabled: options?.enabled,
        });

    const useAdminCoasForDatabasesQuery = (
        databaseIds: number[],
        options?: { enabled?: boolean },
    ) =>
        useQuery({
            queryKey: adminKeys.coasForDatabases(databaseIds),
            queryFn: async () => {
                const response =
                    await apiODIN.getAdminCoAsForDatabaseIds(databaseIds);
                return response.data;
            },
            enabled: (options?.enabled ?? true) && databaseIds.length > 0,
        });

    return {
        useAdminDatabasesQuery,
        useAdminCoasForDatabasesQuery,
    };
};

export type TAdminQueryHooks = ReturnType<typeof createAdminQueryHooks>;
